const keyMap = {
  MULTISELECT_ALL: ["Shift+s", "Shift+S"],
  ADD_NEW_DX: ["d", "D"],
  APPROVE_SELECTED: ["a", "A"],
  REMOVE_SELECTED: ["r", "R"],
  APPROVE_ALL: ["Shift+a", "Shift+A"],
  REMOVE_ALL: ["Shift+r", "Shift+R"],
  SELECT_DX_ONE: ["Shift+1"],
  SELECT_DX_TWO: ["Shift+2"],
  SELECT_DX_THREE: ["Shift+3"],
  SELECT_DX_FOUR: ["Shift+4"],
  SELECT_DX_FIVE: ["Shift+5"],
  SELECT_DX_SIX: ["Shift+6"],
  SELECT_DX_SEVEN: ["Shift+7"],
  SELECT_DX_EIGHT: ["Shift+8"],
  SELECT_DX_NINE: ["Shift+9"],
  REMOVE_DX_ONE: ["Control+1"],
  REMOVE_DX_TWO: ["Control+2"],
  REMOVE_DX_THREE: ["Control+3"],
  REMOVE_DX_FOUR: ["Control+4"],
  REMOVE_DX_FIVE: ["Control+5"],
  REMOVE_DX_SIX: ["Control+6"],
  REMOVE_DX_SEVEN: ["Control+7"],
  REMOVE_DX_EIGHT: ["Control+8"],
  REMOVE_DX_NINE: ["Control+9"],
  APPROVE_DX_ONE: ["Alt+1"],
  APPROVE_DX_TWO: ["Alt+2"],
  APPROVE_DX_THREE: ["Alt+3"],
  APPROVE_DX_FOUR: ["Alt+4"],
  APPROVE_DX_FIVE: ["Alt+5"],
  APPROVE_DX_SIX: ["Alt+6"],
  APPROVE_DX_SEVEN: ["Alt+7"],
  APPROVE_DX_EIGHT: ["Alt+8"],
  APPROVE_DX_NINE: ["Alt+9"]
}

export default keyMap;
